import { pathOr } from 'ramda';

import { IState } from '../../store';
import { IPriceRelevance } from '../../types/priceRelevance';

export function getPriceRelevance(state: IState): IPriceRelevance | null {
  return pathOr(null, ['offerData', 'priceRelevance'], state);
}
